import gql from 'graphql-tag';

import { showConfirmationModal } from 'actions/confirmationModal';
import { updateShareVideo } from 'actions/shareVideo';
import { getGraphQLClient } from 'utilities/graphql';

import UpdateUserPinnedVideo from './UpdateUserPinnedVideo.graphql';

export function updateUserPinnedVideo(item, sort, userInSameWorkspace) {
  return dispatch => {
    const gqlClient = getGraphQLClient();

    gqlClient
      .mutate({
        mutation: UpdateUserPinnedVideo,
        variables: {
          videoId: item.id,
          sort,
        },
      })
      .then(async () => {
        if (sort === 1) {
          if (!userInSameWorkspace) {
            const { data } = await gqlClient.query({
              query: gql`
                query organization($id: ID!) {
                  organization(id: $id) {
                    id
                    name
                    workspaceLogoPath
                  }
                }
              `,
              variables: { id: item.organization_id },
            });

            if (data?.organization) {
              dispatch(
                showConfirmationModal(
                  `Video pinned to profile for ${data?.organization.name}!`
                )
              );
            }
          } else {
            dispatch(showConfirmationModal('Video pinned to profile!'));
          }
        }

        dispatch(
          updateShareVideo({
            ...item,
            isPinned: !item.isPinned,
          })
        );
      });
  };
}
